'use client';

import { useEffect } from 'react';
import { trackEvent } from '../lib/analytics/posthog';
import { EVENTS } from '../lib/analytics/events';

export default function NotFoundTracker() {
  useEffect(() => {
    trackEvent(EVENTS.ERROR_PAGE_VIEWED, {
      error_type: '404',
      url: window.location.href,
      referrer: document.referrer || null,
    });
  }, []);

  return null;
}
